import React from "react";

interface ConnectWalletModalProps {
  className?: string;
  onClose: () => void;
  onClick: (rating: number) => void;
  onConnect: () => void;
}

const ConnectWalletModal = ({
  className,
  onClose,
  onClick,
  onConnect,
}: ConnectWalletModalProps) => {
  return (
    <div className={className}>
      <div className="relative bg-black">
        <header className="relative flex justify-start items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-[#0099FE] ">
          <div className="text-[30px]">
            <span>CONNECT WALLET</span>
          </div>
          <div
            className="absolute right-[20px] w-[29px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-center items-center pb-[30px] pl-[54px] pr-[54px] text-[24px]">
          <div className="text-[24px] flex flex-col gap-2 text-center font-spline-sans-mono py-[30px]">
            <span className="text-[#FE0000] text-[28px]">Not Logged In!</span>
            <span className="text-[21px]">
              To continue, please connect your TON wallet.
            </span>
          </div>

          <div className="w-full relative custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out">
            <img
              src="/assets/button.svg"
              alt="button-image"
              className="w-full h-full object-contain"
            />
            <div
              className="absolute top-0 w-full h-full flex items-center justify-center gap-2"
              onClick={onConnect}
            >
              <span className="text-[20px]">Connect Wallet</span>
              <div>
                <img
                  src="/assets/connect-wallet.svg"
                  className="w-[33px] h-[30px]"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ConnectWalletModal;
